(() => {
  const paginationContainerCSSSelector = '.js-swiper-pagination';
  const bulletClassName = 'slider_pagination_bullet';
  const bulletActiveClassName = 'slider_pagination_bullet--active';
  new Swiper('.swiper', {
    effect: 'fade',
    speed: 800,
    autoplay: {
      delay: 6000,
    },
    pagination: {
      el: paginationContainerCSSSelector,
      bulletClass: bulletClassName,
      bulletActiveClass: bulletActiveClassName,
      clickable: true,
      renderBullet: function (index, className) {
        // ページネーションボタンに画像を使う設定
        const imageUrls = [];
        const sliderImageClassName = 'js-slider-image';
        const sliderImages = document.getElementsByClassName(sliderImageClassName);
        for (const sliderImage of sliderImages) {
          imageUrls.push(sliderImage.getAttribute('data-src'));
        }
        return `<span class="${className}" style="background-image:url(${imageUrls[index]});"></span>`;
      },
    },
  });
})();
